import React from 'react';
import Layout from '../components/site/Layout';
import { PageHero, CtaBanner } from '../components/site/PageParts';
import { LogoMarquee, Platform } from '../components/home/Sections';
import { Reveal } from '../components/site/motion';
import useLang from '../i18n/useLang';

const TOOLS = ['SAP S/4HANA', 'SAP CDS', 'UMH', 'Kepware', 'BarTender', 'OPC UA', 'MQTT'];

function Chips({ items, ltr }) {
  return (
    <ul dir={ltr ? 'ltr' : undefined} className={`mt-4 flex flex-wrap gap-2 ${ltr ? 'rtl:justify-end' : ''}`}>
      {items.map((item) => (
        <li key={item} className="rounded-full bg-white px-3.5 py-1.5 text-[0.95rem] text-ink ring-1 ring-mint-200">
          {item}
        </li>
      ))}
    </ul>
  );
}

export default function AboutGrovv() {
  const { t } = useLang();
  const asList = (k) => {
    const v = t(k, { returnObjects: true });
    return Array.isArray(v) ? v : [];
  };
  const story = asList('pages.about.story');
  const areas = asList('home.hero.areas');

  return (
    <Layout title={t('header.About')}>
      <PageHero title={t('pages.about.title')} lead={t('pages.about.lead')} />

      <section className="wrap grid grid-cols-1 gap-12 py-20 sm:py-24 lg:grid-cols-[1.5fr_1fr] lg:gap-20">
        <div className="space-y-7">
          {story.map((p, i) => (
            <Reveal as="p" key={i} delay={i * 90} className="text-[1.15rem] leading-[1.8] text-ink-600">
              {p}
            </Reveal>
          ))}
        </div>
        <Reveal as="aside" delay={120} className="self-start rounded-4xl bg-mint-50 p-8 sm:p-10">
          <h2 className="heading text-xl text-ink">{t('pages.about.processTitle')}</h2>
          <Chips items={areas} />
          <h2 className="heading mt-9 text-xl text-ink">{t('pages.about.toolsTitle')}</h2>
          <Chips items={TOOLS} ltr />
          <p className="mt-9 border-t border-mint-200 pt-6 text-[0.95rem] text-ink-500">{t('site.footer.address')}</p>
        </Reveal>
      </section>

      <Platform />
      <LogoMarquee />
      <CtaBanner />
    </Layout>
  );
}
